import React from "react";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import Gallery from "../components/site/Gallery";
import Pricing from "../components/site/Pricing";
import WhyUs from "../components/site/WhyUs";
import ServiceAreas from "../components/site/ServiceAreas";
import Booking from "../components/site/Booking";
import TestReportSection from "../components/site/TestReportSection";
import FAQ from "../components/site/FAQ";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingCall from "../components/site/FloatingCall";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-white text-slate-900">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Pricing />
        <WhyUs />
        <ServiceAreas />
        <Booking />
        <TestReportSection />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}
